var map = {
	"./arrow-down.svg": 35614,
	"./arrow-ideal.svg": 31655,
	"./error_small.svg": 19097,
	"./fail.svg": 13176,
	"./global-stone.svg": 70910,
	"./global.svg": 95871,
	"./ib.svg": 16919,
	"./icon-add.svg": 7063,
	"./icon-arrow-down.svg": 71138,
	"./icon-arrow-right.svg": 95512,
	"./icon-arrow-solid-down.svg": 41376,
	"./icon-buy-gray.svg": 26051,
	"./icon-buy.svg": 16464,
	"./icon-cart-gray.svg": 51931,
	"./icon-cart-red.svg": 9162,
	"./icon-cart-white.svg": 18,
	"./icon-cart.svg": 1683,
	"./icon-category.svg": 34213,
	"./icon-check.svg": 38978,
	"./icon-checked.svg": 23244,
	"./icon-close-white.svg": 94071,
	"./icon-close.svg": 4918,
	"./icon-copy-gray.svg": 81784,
	"./icon-copy.svg": 77239,
	"./icon-default.svg": 60068,
	"./icon-delete.svg": 63804,
	"./icon-donation.svg": 60938,
	"./icon-download.svg": 71474,
	"./icon-edit-gray.svg": 4329,
	"./icon-edit.svg": 88032,
	"./icon-email.svg": 23005,
	"./icon-facebook.svg": 94114,
	"./icon-faq.svg": 82298,
	"./icon-ib.svg": 92790,
	"./icon-in.svg": 44729,
	"./icon-input-close.svg": 59274,
	"./icon-invalid-name.svg": 75217,
	"./icon-kefu.svg": 47113,
	"./icon-phone.svg": 39517,
	"./icon-plus.svg": 37367,
	"./icon-reduce.svg": 44147,
	"./icon-search.svg": 30814,
	"./icon-share-black.svg": 32975,
	"./icon-share-white.svg": 424,
	"./icon-sort-down.svg": 79509,
	"./icon-sort-up-red.svg": 60520,
	"./icon-sort-up.svg": 64352,
	"./icon-sqar.svg": 73777,
	"./icon-success-big.svg": 99645,
	"./icon-success.svg": 12634,
	"./icon-t.svg": 3957,
	"./icon-top.svg": 8227,
	"./icon-trash-black.svg": 75701,
	"./icon-trash-gray.svg": 63456,
	"./icon-trash.svg": 47758,
	"./icon-twitter.svg": 48821,
	"./icon-user-red.svg": 99009,
	"./icon-user.svg": 34359,
	"./icon-warning.svg": 22706,
	"./icon-wechat.svg": 46144,
	"./kefu.svg": 40386,
	"./logo_new.svg": 3257,
	"./success.svg": 94836,
	"./top.svg": 49973
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34007;